export default __webpack_public_path__ + "static/media/appname.d814f55a.svg";